module.exports = __webpack_public_path__ + "dce455a731d707ad9f6f4d4b60bb78fa.svg";